module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"standards_title":"Standards im Unternehmen","standards_import_btn":"Import Standard"},"en":{"standards_title":"Used Standards","standards_import_btn":"Import Standard"}}')
  delete Component.options._Ctor
}
